import { TimeReportingProjectFormTypes } from "models/formTypes";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";

// Returns the new-category names for which this member is assigned but has no valid hourly rate.
// Returns [] if the member is not a self-billing HourlyRate member.
export const getMissingSelfBillingCategoryNamesForMember = (
  values: TimeReportingProjectFormTypes.Create,
  member: TimeReportingProjectFormTypes.ProjectMember
): string[] => {
  if (
    !member.selfBillingEnabled ||
    member.selfBillingCalculationMethod !== ApiModel.SelfBillingCalculationMethod.HourlyRate
  ) {
    return [];
  }
  const newCategories = values.projectCategories?.filter((c) => !c.id || c.isNew) ?? [];
  const missingCategoryNames: string[] = [];
  newCategories.forEach((category) => {
    const isAssigned = values.projectCategoryMembers?.some(
      (pcm) =>
        pcm.projectMember?.id === member.id &&
        (pcm.projectCategory?.name === category.name ||
          (pcm.projectCategory?.id && category.id && pcm.projectCategory.id === category.id))
    );
    if (!isAssigned) return;
    const hasValidRate = member.selfBillingHourlyRates?.some((rate) => {
      const matchesCategory =
        (rate.timeReportingProjectCategoryId &&
          category.id &&
          rate.timeReportingProjectCategoryId === category.id) ||
        rate.categoryName === category.name;
      return matchesCategory && rate.amount !== undefined && rate.amount !== null && rate.amount > 0;
    });
    if (!hasValidRate) missingCategoryNames.push(category.name);
  });
  return missingCategoryNames;
};

// Returns names of self-billing (HourlyRate) members assigned to a new category without a rate
// for it. The !c.id branch covers the default Normaltid in create flow (no id, no isNew flag).
export const findSelfBillingMembersMissingRateForNewCategories = (
  values: TimeReportingProjectFormTypes.Create
): string[] => {
  const newCategories = values.projectCategories?.filter((c) => !c.id || c.isNew) ?? [];
  if (newCategories.length === 0) return [];

  const selfBillingMembers =
    values.projectMembers?.filter(
      (m) =>
        m.selfBillingEnabled &&
        m.selfBillingCalculationMethod === ApiModel.SelfBillingCalculationMethod.HourlyRate
    ) ?? [];
  if (selfBillingMembers.length === 0) return [];

  const missingMemberNames = new Set<string>();
  selfBillingMembers.forEach((member) => {
    if (getMissingSelfBillingCategoryNamesForMember(values, member).length > 0 && member.name) {
      missingMemberNames.add(member.name);
    }
  });
  return Array.from(missingMemberNames);
};
